import React from 'react'
import clsx from 'clsx'
import { ReactComponent as Logo } from 'images/logo.svg';
import BackBtn from 'components/shared/BackBtn';
import Modal from 'components/shared/modals/Modal';
import styles from './AuthModal.module.scss';

function AuthModal({
  title,
  onBack,
  onClose,
  children,
  showLogo,
  className,
}: {
  title?: string,
  onBack?: () => void,
  onClose?: () => void,
  children?: React.ReactNode,
  showLogo?: boolean,
  className?: string,
}) {
  return (
    <Modal
      onClose={onClose}
      showCloseBtn={Boolean(onClose)}
      className={clsx(styles.modal, className)}
      isOpen
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          width: '100%',
          alignItems: 'center'
        }}
      >
        {onBack ? (
          <BackBtn
            className={styles.btnBack}
            onClick={onBack}
          />
        ) : null}
        {title ? (<div className={styles.header}>{title}</div>) : null}
        <div className={styles.btnBack} />
      </div>
      {children}
    </Modal>
  )
}

export default AuthModal
